// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"8b87fe80","40":"f875f95c","197":"c03397fe","453":"59a9211b","497":"123837da","766":"4e7806db","796":"7bcc5deb","830":"7982917a","954":"baf7ce44","969":"6a12e63d","981":"242d387e"}[chunkId] + ".chunk.js";
};